import CustomerPortalView from './CustomerPortalView';
import authRoles from '../../auth/authRoles';

const CustomerPortalConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'portal/:visibilityId',
      element: <CustomerPortalView />,
    },
  ],
};

export default CustomerPortalConfig;
